import { topicIndex } from '@/mocks/homeData';

export default function TopicIndexSection() {
  return (
    <section id="index" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-600 bg-primary-50 rounded-full mb-4">
            分类浏览
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按话题分类探索你感兴趣的吃瓜内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {topicIndex.map((topic) => (
            <a
              key={topic.id}
              href="#carousel"
              className="group flex items-center gap-4 p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200/60 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div
                className={`w-11 h-11 rounded-xl flex items-center justify-center ${topic.color} shrink-0`}
              >
                <i className={`${topic.icon} text-lg text-white`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  {topic.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-0.5">
                  {topic.count} 篇内容
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}